import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { injectLogger } from './logger-injection';

export const loggingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = injectLogger('HttpErrorInterceptor');

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      logger.error(error.message, {}, error);
      return throwError(() => error);
    }),
  );
};
